import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { NavigationRoutes } from '../../../../../../modules/Header/constants/navigationRoutes';
import { trackMenuClickUserAction } from '../../../../../../common/analytics/menu/MenuUserAction';
import { Description, DescriptionWrapper, Panel, RouteImagesWrapper, Subtitle, Title, } from '../LimitedEditionsPanel/LimitedEditionsPanel.styled';
import { RouteImage } from '../shared/RouteImage/RouteImage';
import { ACCESSORIES_NAV_IMG_PATH } from './constants';
export const AccessoriesPanel = () => {
    const accessoriesRouteTitle = 'Mounting & Add-ons';
    const giftCardRouteTitle = 'Gift Cards';
    return (_jsxs(Panel, { children: [_jsxs(DescriptionWrapper, { children: [_jsx(Title, { children: "Displate accessories" }, void 0), _jsx(Subtitle, { children: "For all your non-printed needs" }, void 0), _jsxs(Description, { children: ["From magnet-mounting your Displates, to making selected artworks pop. We have some accessories to satisfy first-timers and big collectors alike.", _jsx("br", {}, void 0), _jsx("br", {}, void 0), "Get your spare magnets here!"] }, void 0)] }, void 0), _jsxs(RouteImagesWrapper, { children: [_jsx(RouteImage, { alt: accessoriesRouteTitle, buttonText: "Discover all", dataTestId: "accessories-panel-accessories", description: _jsx(_Fragment, { children: "Mounting & Add-ons" }, void 0), images: {
                            jpg: {
                                x1: `${ACCESSORIES_NAV_IMG_PATH}/mounting_addons_v2@1x.jpg`,
                                x2: `${ACCESSORIES_NAV_IMG_PATH}/mounting_addons_v2@2x.jpg`,
                            },
                            avif: {
                                x1: `${ACCESSORIES_NAV_IMG_PATH}/mounting_addons_v2@1x.avif`,
                                x2: `${ACCESSORIES_NAV_IMG_PATH}/mounting_addons_v2@2x.avif`,
                            },
                            webp: {
                                x1: `${ACCESSORIES_NAV_IMG_PATH}/mounting_addons_v2@1x.webp`,
                                x2: `${ACCESSORIES_NAV_IMG_PATH}/mounting_addons_v2@2x.webp`,
                            },
                        }, onClick: (event) => {
                            trackMenuClickUserAction({
                                event,
                                panelTitle: 'Acessories',
                                linkName: '',
                                columnTitle: accessoriesRouteTitle,
                                elementType: 'Link',
                            });
                        }, url: NavigationRoutes.ACCESSORIES }, void 0), _jsx(RouteImage, { alt: giftCardRouteTitle, buttonText: "Get a gift card", dataTestId: "accessories-panel-gift-card", description: giftCardRouteTitle, images: {
                            jpg: {
                                x1: `${ACCESSORIES_NAV_IMG_PATH}/gift_cards_Xmas@1x.jpg`,
                                x2: `${ACCESSORIES_NAV_IMG_PATH}/gift_cards_Xmas@2x.jpg`,
                            },
                            avif: {
                                x1: `${ACCESSORIES_NAV_IMG_PATH}/gift_cards_Xmas@1x.avif`,
                                x2: `${ACCESSORIES_NAV_IMG_PATH}/gift_cards_Xmas@2x.avif`,
                            },
                            webp: {
                                x1: `${ACCESSORIES_NAV_IMG_PATH}/gift_cards_Xmas@1x.webp`,
                                x2: `${ACCESSORIES_NAV_IMG_PATH}/gift_cards_Xmas@2x.webp`,
                            },
                        }, onClick: (event) => {
                            trackMenuClickUserAction({
                                event,
                                panelTitle: 'Acessories',
                                linkName: '',
                                columnTitle: giftCardRouteTitle,
                                elementType: 'Link',
                            });
                        }, url: NavigationRoutes.GIFT_CARD }, void 0)] }, void 0)] }, void 0));
};
//# sourceMappingURL=AccessoriesPanel.js.map